import React, {useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { urlFor, client } from '../../client';
import { AppWrap, MotionWrap } from '../../wrapper';
import './About.scss';
import { images } from '../../constants';

const About = () => {
  const [abouts, setAbouts] = useState([]);
  useEffect(() => {
    const query = '*[_type == "abouts"]';
    client.fetch(query)
      .then((data) => setAbouts(data))
  }, []);
  return (
    <>
      <h2 className='head-text'>
        I Know that 
        <span> Perfectionism </span><br></br>
        means
        <span> Good Impressions </span>
      </h2>

      <h4 className='head-text' style={{ fontSize: 13, paddingTop: 9 }}>I am discplined, organized and work-focused graduate, seeking entry-level position as a Python Developer/ML Engineer/Data Scientist. Many of my project revolves around this tech-stack. And I keep myself updated in latest frameworks belonging to them.</h4>

      <div className='app__profiles'>
        {abouts.map((about, index)=> (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: 'tween' }}
            className="app__profile-item"
            key={about.title + index}
          >
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className='bold-text' style={{ marginTop: 20 }}>{about.title}</h2>
            <p className='p-text' style={{ marginTop: 10 }}>{about.description}</p>
          </motion.div>
        ))}
      </div>
      <div>
        <a href={images.resume} download="Shivam Manishbhai Sarang" style={{ textDecoration: 'none' }}><button type='button' className='p-text' style={{ color: '#fff' }}>Download C.V.</button></a>
      </div>
    </>
  )
}

export default AppWrap(MotionWrap(About, 'app__about'), 'about', "app__whitebg");